import SelectInput from '../global/SelectInput';
import noData from '../../assets/images/tbh/dashboardImages/no-data.png';

type OverviewProps = {
  type?: 'mobile';
};
const Overview = ({ type }: OverviewProps) => {
  return (
    <div
      className={`mt-[16px] border-[0] md:border-[#DDDDDD] rounded-md md:border h-full py-3 ${
        !type && 'px-3'
      }`}
    >
      <div className='space-y-2'>
        <div className={`flex items-center ${!type && 'justify-between'}  `}>
          <div className='flex items-center justify-between   space-x-3'>
            <h2 className='font-normal font-poppins text-[13.57px] text-[#212121]'>Overview</h2>
            <SelectInput size='sm' option='NGR' />
          </div>
          <div className='ml-4'>
            <SelectInput className='w-[106px] ' size='md' option='Last 7 Days' />
          </div>
        </div>
        {!type && <div className='border-b-[1px]  border-[#CDD5D5]'></div>}
      </div>
      <div
        className={`flex justify-center h-[calc(100%-30px)] items-center ${type && 'mt-[76px]'}`}
      >
        <div className='space-y-5 text-center'>
          <img src={noData} alt='no-record' />
          <h2 className='text-base font-poppins text-black'>No data to show for this period</h2>
          <p className='font-poppins text-[10px] text-[#768396] font-normal'>
            Your over transaction activities when sell a produc or offer a service or receive
            payment.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Overview;
